import { render, staticRenderFns } from "./BodyRegister.vue?vue&type=template&id=2e93a9b8"
import script from "./BodyRegister.vue?vue&type=script&lang=ts"
export * from "./BodyRegister.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports